import React from "react";
import "./apigrid.css";
import { Link } from "react-router-dom";
const s3url = process.env.REACT_APP_ASSETS_CL_URL;

const APIGrid = () => {
  return (
    <div className="api-grid-container" id="learn-more">
      {/* Header Section */}
      <div className="header-section">
        <h3 className="api-grid-heading">
          The <span className="brand-text">Be </span>
          Suite
        </h3>
        <p className="api-grid-subtitle">
          One Mission. Six precision-built tools that help you validate, verify,
          and operate with confidence.
        </p>
      </div>

      {/* Grid Layout */}
      <div className="masonry-grid">
        {/* Column 1 Cards */}

        {/* Valid Email Card - Row 1 to 2 */}
        <div className="api-card  email-card grid-item-1-1">
          <div className="email-input">
            <img
              src={`${s3url}/BounceProof.gif`}
              alt="Email validation animation"
            />
          </div>
          <div className="email-card-text">
            <div className="image-text">
              <img src="/images/Frame (1).svg" alt="" />
              <h3>BounceProof</h3>
            </div>
            <p>Catch bad emails before they derail your next big campaign.</p>
            <Link to="/bounce-proof" className="learn-more">
              Learn More
            </Link>
          </div>
        </div>

        {/* OCRProof Card - Row 4 */}
        <div className="api-card ocr-card grid-item-1-2">
          <div className="ocr-card-text">
            <div className="image-text">
              <img src="/images/Frame (4).svg" alt="" />
              <h3>OCRProof</h3>
            </div>
            <p>Turn unreadable files into clean, usable data in seconds.</p>
            <Link to="#" className="coming-soon">
              Coming Soon
            </Link>
          </div>
          <div className="ocr-box">
            <img src={`${s3url}/OCRProof.gif`} alt="" />
          </div>
        </div>

        {/* Column 2 Cards */}

        {/* TamperProof Text Card - Row 1 to 3 */}
        <div className="api-card  tamper-card grid-item-2-1">
          <div className="tamper-card-text">
            <div className="image-text">
              <img src="/images/Frame (3).svg" alt="" />
              <h3>TamperProof</h3>
            </div>
            <p>
              Spot hidden document changes before they cause serious trouble.
            </p>
            <Link to="/tamper-proof" className="learn-more">
              Learn More
            </Link>
          </div>
          <div className="tamper-box">
            <img src={`${s3url}/TamperProof.gif`} alt="tamperproof gif" />
          </div>
        </div>

        {/* Financial Statement Card - Row 3 to 4 */}
        <div className="api-card  financial-card grid-item-2-2">
          <div className="financial-box">
            <img src={`${s3url}/Financial Statement.gif`} alt="" />
          </div>
          <div className="financial-card-text">
            <div className="image-text">
              <img src="/images/Frame (5).svg" alt="" />
              <h3>Finnalyzer</h3>
            </div>
            <p>
              See hidden risks in statements before approving loans or credit.
            </p>
            <Link to="/finnalyzer" className="learn-more">
              Learn More
            </Link>
          </div>
        </div>

        {/* Column 3 Cards */}

        {/* IDProof Text Card - Row 1 to 2 */}
        <div className="api-card  id-card grid-item-3-1">
          <div className="id-card-text">
            <div className="image-text">
              <img src="/images/Frame (2).svg" alt="" />
              <h3>IDProof</h3>
            </div>
            <p>Validate identities in seconds before fraud slips through.</p>
            <Link to="/id-proof" className="learn-more">
              Learn More
            </Link>
          </div>
          <div className="id-proof-box">
            <img src={`${s3url}/IDProof.gif`} alt="" />
          </div>
        </div>

        {/* Trustify Card - Row 2 to 4 */}
        <div className="api-card  trustify-card grid-item-3-3">
          <div className="trustify-box">
            <img src={`${s3url}/Trustiify.gif`} alt="" />
          </div>
          <div className="trustify-card-text">
            <div className="image-text">
              <img src="/images/Frame (6).svg" alt="" />
              <h3>Trustiify</h3>
            </div>
            <p>Know exactly who to trust with a verified identity score.</p>
            <Link to="#" className="coming-soon">
              Coming Soon
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default APIGrid;
